import React, { Component } from 'react'
import styled from "styled-components"
import PropTypes from "prop-types";
import html2canvas from 'html2canvas';
import { translate } from "react-i18next"

const MenuContainer = styled.div`
  position: absolute;
  left: ${props => props.left};
  top: ${props => props.top};
  display: ${props => props.display};
  z-index: 100;
`

const MenuIcon = styled.i`
  color: #000;
  padding: 2px 5px 2px 5px;

  &:hover {
    background-color: #E5E5E5;
    cursor: pointer;
  }
`

const MenuArea = styled.div`
  box-shadow: rgb(136, 136, 136) 3px 3px 10px;
  border: 1px solid rgb(153, 153, 153);
  background: rgb(255, 255, 255);
  padding: 5px 0px;
  z-index: 100;
  position: absolute;
  right: 0px;
`

const MenuItem = styled.div`
  cursor: pointer;
  padding: 0.5em 1em;
  background: none;
  color: rgb(51, 51, 51);
  font-size: 11px;
  transition: background 250ms ease 0s, color 250ms ease 0s;
  width: 150px;

  &:hover {
    background-color: #365CAB;
    color: #FFF;
  }
`

class ExportMenu extends Component {
  state = {
    showMenu: false,
  };  
  showMenu = (event) => {
    event.preventDefault();    
    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }  
  closeMenu = (event) => {   
    this.setState({ showMenu: false }, () => {
      document.removeEventListener('click', this.closeMenu);
    });
  }
  exportPNG = () => {
    var element = document.getElementById(this.props.widgetIdentifier)
    if (element != null) {
      var fileName = this.props.t(this.props.titleKey) + '.png'
      // To ensure we don't have the any elements in the snapshot that shouldn't be there
      // We reset the display prop from the parent to hide the menu, as well as closing 
      // the menu.
      this.props.resetDisplayProp()
      this.setState({ showMenu: false }, () => {
        html2canvas(element, { logging:false, allowTaint:true }).then(function(canvas) {
          var link = document.createElement('a');
          link.download = fileName;
          link.href = canvas.toDataURL();
          link.click();
        });
      });
    } 
  }
  exportJPEG = () => {
    var element = document.getElementById(this.props.widgetIdentifier)
    if (element != null) {
      var fileName = this.props.t(this.props.titleKey) + '.jpeg'
      // To ensure we don't have the any elements in the snapshot that shouldn't be there
      // We reset the display prop from the parent to hide the menu, as well as closing 
      // the menu.
      this.props.resetDisplayProp()
      this.setState({ showMenu: false }, () => {
        html2canvas(element, { logging:false, allowTaint:true }).then(function(canvas) {
          var link = document.createElement('a');          
          link.download = fileName;
          link.href = canvas.toDataURL();
          link.click();
        });
      });
    } 
  }
  render() {
    const { display, left, top } = this.props
    return (
      <MenuContainer display={display} left={left} top={top}>
        <MenuIcon onClick={this.showMenu} title="Chart Download Options" className="fa fa-bars"></MenuIcon>    
        {
          this.state.showMenu
            ? (
              <MenuArea
                ref={(element) => {
                  this.dropdownMenu = element;
                }}
              >
                <MenuItem onClick={this.exportPNG}>Download PNG image</MenuItem>
                <MenuItem onClick={this.exportJPEG}>Download JPEG image</MenuItem>
              </MenuArea>
            )
            : (
              null
            )
        }
      </MenuContainer>
    );
  }
}

ExportMenu.propTypes = {
  display: PropTypes.string,
  left: PropTypes.string.isRequired,
  top: PropTypes.string.isRequired,
  widgetIdentifier: PropTypes.string.isRequired,
  resetDisplayProp: PropTypes.func.isRequired,
  titleKey: PropTypes.string
}

ExportMenu.defaultProps = {
  display: "initial",
  titleKey: "chart"
}

export default translate()(ExportMenu)


// WEBPACK FOOTER //
// ./src/components/themed-html-components/ExportMenu.jsx